<template>
  <div class="chat">
    <a class="pitaBanner" href="https://bit.ly/pitacoin">
      <img src="../assets/banner_pitacoin.png" alt="">
    </a>
    <!--<h2>アプリをインストールして、<br class="sp">チャットに参加しよう！</h2>-->
    <div class="appBtns">
        <a target="_blank" href="http://bit.ly/2FKKxlq">
          <img width="188" src="../assets/app_android.png">
        </a>
        <a target="_blank" href="https://apple.co/2E0HG6x">
          <img width="188" src="../assets/app_ios.png">
        </a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Chat',
  components: {
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sp{
  display: none;
}
.chat{
  text-align: center;
  padding-bottom: 40px;
}
h2{
  font-size: 20px;
  padding: 0 2vw;
}
.pitaBanner{
  padding-top: 40px;
  display: inline-block;
}
.appBtns{
  padding-top: 20px;
}
@media all and (max-width: 740px) {
  .sp{
    display: inline-block;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Chat.vue